<bey-preview-header (close)="location.back()" class="block"></bey-preview-header>
<bey-link-interaction [isPreview]="true" [forceMobile]="false" class="block"></bey-link-interaction>
<bey-navigation-footer (stepChange)="togglePreviewStep($event)" class="block"></bey-navigation-footer>
